import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FundraisingSite } from '../../_models/fundraising/FundraisingSite';
import { BaseService } from '../../_shared/base.service';
import { getUrl } from '../../_shared/utils';
import { JWTTokenService } from '../jwtToken.service';

export abstract class FundraisingSiteService extends BaseService {

    public apiUrl = getUrl();

    constructor(
        protected http: HttpClient,
        protected jwtTokenService: JWTTokenService) 
        {
            super(http, jwtTokenService);
        }

    public abstract create(data: FundraisingSite): Observable<FundraisingSite>

    public abstract update(data: FundraisingSite): Observable<FundraisingSite> 

    public abstract getHostnameAvailability(name: string): Observable<any>;

    public abstract deleteLegalPdf(bucketName: string, objectPath: string): Observable<boolean>;

    protected requestOptionsAuthenticated(tokenKey: string) {
        const requestOptions = {
            headers: new HttpHeaders()
                .set('Content-type', 'application/json')
                .append('Authorization', 'Bearer ' + this.jwtTokenService.getToken(tokenKey)),
        };
        return requestOptions;
    }

}